import React, { ReactNode } from 'react';

type PageSectionProps = {
    children: ReactNode,
    className?: string,
};

const PageSection = ({
    children = null,
    className = '',
} : PageSectionProps) => (
    <div className={className}>
        {children}
    </div>
);

export default PageSection;
